import { Box } from '@mui/material';

import { screenSize } from 'Lib/utilities/screenSize';

const PageBody = props => {
    const { mobile } = screenSize();

    return (
        <Box className={`page-body ${props.className?.body || ''}`} sx={{ px: !mobile && 4, overflow: !mobile && 'hidden' }}>
            {props.children}
        </Box>
    );
};

export default PageBody;
